import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Box from '@rexlabs/box';

import { styled, StyleSheet } from '@rexlabs/styling';
import colorTheme from '../../../utils/color-theme';
import charLimit, { limits } from '../../../utils/char-limit';
import ScaledText from '../../scaled-text';
import { LargeButton } from '../../button';
import { COLORS } from 'src/theme';
import _ from 'lodash';

const fontFamily = 'Lato, sans-serif';
const defaultStyles = StyleSheet({
  netboard: {
    overflow: 'hidden',
    border: '1px solid darkgray',
    width: 580,
    height: 400,
    display: 'flex',
    flexDirection: 'column'
  },
  main: {
    height: 330,
    width: '100%',
    display: 'flex'
  },
  content: {
    flex: 1,
    width: '50%',
    display: 'flex',
    flexDirection: 'column'
  },
  shortHeadlineWrapper: {
    flex: 1,
    backgroundColor: '#F8F8F8',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 32px'
  },
  shortHeadline: {
    fontSize: 27,
    fontFamily,
    fontWeight: 500,
    lineHeight: '27px'
  },
  agentDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '0 32px',
    backgroundColor: 'white'
  },
  agentName: {
    fontFamily,
    fontWeight: 300
  },
  suburb: {
    fontFamily,
    fontSize: 15,
    fontWeight: 600,
    lineHeight: '18px',
    textTransform: 'uppercase'
  },
  primaryImage: {
    flex: 1,
    width: '50%',
    height: '100%',
    objectFit: 'cover'
  },
  footer: {
    height: 70,
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '15px 17px'
  },
  logo: {
    height: '100%',
    width: 'auto',
    maxWidth: '50%',
    objectFit: 'contain'
  }
});

@styled(defaultStyles)
class Netboard extends PureComponent {
  static propTypes = {
    shortHeadline: PropTypes.string,
    agentName: PropTypes.string,
    description: PropTypes.string,
    brandColor: PropTypes.string,
    buttonText: PropTypes.string,
    primaryImageUrls: PropTypes.object,
    logoUrls: PropTypes.object
  };

  static defaultProps = {
    buttonText: 'Learn more'
  };

  render() {
    const {
      shortHeadline,
      agentName,
      agentPosition,
      agencyName,
      brandColor,
      backgroundColor,
      buttonText,
      primaryImageUrls,
      logoUrls,
      styles: s
    } = this.props;

    const { brandColorBorder } = colorTheme(brandColor);

    return (
      <Box {...s('netboard')}>
        <Box {...s('main')}>
          <Box {...s('content')}>
            <Box {...s('shortHeadlineWrapper')}>
              <span {...s.with('shortHeadline')({ color: COLORS.BLACK })}>
                {charLimit(shortHeadline, limits.SHORT_HEADLINE)}
              </span>
            </Box>
            <Box {...s('agentDetails')}>
              <ScaledText
                maxWidth={226}
                maxTextLines={2}
                maxFontSize={36}
                minFontSize={28}
                {...s.with('agentName')({ color: COLORS.BLACK })}
              >
                {agentName}
              </ScaledText>
              <span {...s.with('suburb')({ color: COLORS.BLACK })}>
                {agentPosition} - {agencyName}
              </span>
            </Box>
          </Box>
          <img
            {...s('primaryImage')}
            src={_.get(primaryImageUrls, ['crop.square', 'url'])}
          />
        </Box>
        <Box
          {...s.with('footer')({
            backgroundColor: backgroundColor,
            borderTop: brandColorBorder
          })}
        >
          <img {...s('logo')} src={_.get(logoUrls, 'original.url')} />
          <Box width={124}>
            <LargeButton brandColor={brandColor} invert={false}>
              {buttonText}
            </LargeButton>
          </Box>
        </Box>
      </Box>
    );
  }
}

export default Netboard;
